import React from 'react';

export default function TwoStairsColumns(props: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div className="columns is-gapless as-two-stairs-columns">
            {props.children}
        </div>
    )
}
